import logo from './logo.svg';
import './App.css';
import FeedbackForm from './components/FeedbackForm';

function App() {
  return (
   <>
   <FeedbackForm/>
   </>
  );
}

export default App;
